// extracted by mini-css-extract-plugin
export default {"inbox":"ChatMessagesContainer_inbox__IkbfL"};